import { render } from "./RiskAlertCenter.vue?vue&type=template&id=4a36aedc&scoped=true"
import script from "./RiskAlertCenter.vue?vue&type=script&lang=js"
export * from "./RiskAlertCenter.vue?vue&type=script&lang=js"

import "./RiskAlertCenter.vue?vue&type=style&index=0&id=4a36aedc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a36aedc"]])

export default __exports__